import { http } from './http'

export const getRanRooms = () => {
  return http().get('/api/ran')
}

export const activateRanRoom = () => {
  return http().post('/api/ran')
}

export const resetRanRoom = (roomId) => {
  return http().put(`/api/ran/${roomId}/reset`)
}

export const isRanAvailable = () => {
  return http().get('/api/ran/available')
}
